import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment/moment'
import { apiCollectionPointBagDistributionList } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/collectionPointBagDistribution/getData', async datas => {
    const { data } = await apiCollectionPointBagDistributionList(datas)
    return data
})

export const collectionPointBagDistributionSlice = createSlice({
    name: 'admin/report/collectionPointBagDistribution',
    initialState: {
        loading: true,
        data: [],
        total: 0,
        table: {
            start: moment().startOf('month').locale('en').format('YYYY-MM-DD'),
            end: moment().endOf('month').locale('en').format('YYYY-MM-DD'),
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setDate: (state, { payload: { start, end } }) => {
            state.table.start = start
            state.table.end = end
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
    },
})

export const { setData, setTableData, setDate } = collectionPointBagDistributionSlice.actions

export default collectionPointBagDistributionSlice.reducer
